<template>
  <VDialog v-model="isShowModal" max-width="700">
    <VCard>
      <VToolbar color="white" density="compact">
        <VToolbarTitle>
          <VIcon icon="mdi-email-outline" class="mr-2" />
          {{ comment?.createdDate ?? '-' }}
        </VToolbarTitle>
        <VSpacer />
        <VBtn icon="mdi-close" variant="text" @click="handleClose()" />
      </VToolbar>
      <VCardItem>
        <VCardText>
          <div v-if="isLoading" class="d-flex flex-column align-center justify-center py-4 w-100">
            <VProgressCircular indeterminate color="primary" />
          </div>
          <div v-else class="latest-comment-modal">
            <div class="latest-comment-modal__subject">{{ comment?.subject ?? '-' }}</div>
            <div class="latest-comment-modal__from">
              <div class="latest-comment-modal__label">From</div>
              <div class="latest-comment-modal__box">{{ comment?.fromAddress ?? '-' }}</div>
            </div>
            <div class="latest-comment-modal__to">
              <div class="latest-comment-modal__label">To</div>
              <div class="latest-comment-modal__box">{{ comment?.toAddress ?? '-' }}</div>
            </div>
            <div class="latest-comment-modal__body">
              <div class="latest-comment-modal__label">Email Body</div>
              <div class="latest-comment-modal__body-content">
                <iframe :srcdoc="comment?.body ?? 'Empty'" class="w-100 h-100"></iframe>
              </div>
            </div>
            <div v-if="comment.attachments.length" class="latest-comment-modal__attachments">
              <div class="latest-comment-modal__label">Attachments</div>
              <div
                v-for="attachment in comment.attachments"
                :key="attachment"
                class="latest-comment-modal__attachment"
                @click="downloadAttachment(attachment)"
              >
                <VIcon icon="mdi-paperclip" color="black" />
                <div>{{ attachment.name }}</div>
                <VProgressCircular v-if="attachment.isDownloadLoading" indeterminate color="primary" size="small" />
              </div>
            </div>
          </div>
        </VCardText>
      </VCardItem>
    </VCard>
  </VDialog>
</template>

<script>
import { mapActions } from 'vuex';
// Service
import applicationService from '@/services/application-service/application.service';
import documentsService from '@/services/documents-service/documents.service';
// Utils
import { formatLatestComment } from '@/utils/formatData';
//Text
import { errorViewCommentText, errorDownloadDocumentText } from '@/text/snackbarsText';
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    commentId: String
  },
  computed: {
    isShowModal() {
      if (this.modelValue) this.getLatestComment();
      return this.modelValue;
    }
  },
  data() {
    return {
      isLoading: true,
      comment: {
        createdDate: '',
        subject: '',
        fromAddress: '',
        toAddress: '',
        body: '',
        attachments: []
      }
    };
  },
  methods: {
    ...mapActions('main', ['showSnackbar', 'startLoading', 'stopLoading']),
    async getLatestComment() {
      if (!this.commentId) return;
      this.isLoading = true;
      this.comment = {
        createdDate: '',
        subject: '',
        fromAddress: '',
        toAddress: '',
        body: '',
        attachments: []
      };

      try {
        const { emailMessage } = await applicationService.getLatestComment({
          commentId: this.commentId
        });
        this.comment = formatLatestComment(emailMessage);
      } catch (err) {
        console.error(err);
        this.showSnackbar({ text: errorViewCommentText, color: 'red' });
        this.handleClose();
      } finally {
        this.isLoading = false;
      }
    },

    handleClose() {
      this.$emit('update:modelValue', false);
    },
    getMimeType(fileType = '') {
      switch (fileType.toUpperCase()) {
        case 'PDF':
          return 'application/pdf';
        case 'PNG':
          return 'image/png';
        case 'JPEG':
        case 'JPG':
          return 'image/jpeg';
        case 'GIF':
          return 'image/gif';
        case 'TXT':
          return 'text/plain';
        default:
          return 'application/octet-stream';
      }
    },
    async downloadAttachment(item) {
      const { attachmentId, isDownloadLoading } = item;
      if (!attachmentId || isDownloadLoading) return;
      item.isDownloadLoading = true;

      try {
        const { attachment } = await documentsService.downloadAttachment({
          attachmentId: attachmentId
        });
        const { documentBody, documentType, documentTitle } = attachment;

        const mime = this.getMimeType(documentType ?? '');

        //  Blob URL
        const byteCharacters = atob(documentBody);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mime });
        const documentUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = documentUrl;
        link.download = documentTitle || 'document';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (err) {
        console.error(err);
        this.showSnackbar({
          text: errorDownloadDocumentText,
          color: 'red'
        });
      } finally {
        item.isDownloadLoading = false;
      }
    }
  }
};
</script>
